import EmptyState from '../../../forecast-app/shared/components/empty-states/empty_state';
import {APPROVAL_STATUS} from '../../../constants';

/**
 * Selects the correct EmptyState pageName for a new-status tab (PENDING/DECLINED/INVOICED)
 * when it has no entries. Returns null if selectedTab is not one of the new-status tabs,
 * or if no condition matches (defensive).
 *
 */
export const getNewStatusEmptyState = (selectedTab, counts, hasManageAllPermission) => {
	const {submitted = 0, approved = 0, notSubmitted = 0, pending = 0, declined = 0, invoiced = 0} = counts;
	const totalCount = submitted + approved + notSubmitted + pending + declined + invoiced;

	if (totalCount === 0) {
		return hasManageAllPermission
			? EmptyState.EMPTY_STATE.APPROVAL_NO_REGISTERED
			: EmptyState.EMPTY_STATE.APPROVAL_NO_REGISTERED_ON_OWNED;
	}
	if (selectedTab === APPROVAL_STATUS.PENDING && approved === 0 && declined === 0 && submitted > 0) {
		return EmptyState.EMPTY_STATE.APPROVAL_NOTHING_APPROVED_OR_DECLINED;
	}
	if (selectedTab === APPROVAL_STATUS.INVOICED && approved === 0 && invoiced === 0 && submitted > 0) {
		return EmptyState.EMPTY_STATE.APPROVAL_NOTHING_APPROVED;
	}
	if (selectedTab === APPROVAL_STATUS.PENDING) return EmptyState.EMPTY_STATE.APPROVAL_NOTHING_PENDING;
	if (selectedTab === APPROVAL_STATUS.DECLINED) return EmptyState.EMPTY_STATE.APPROVAL_NOTHING_DECLINED;
	if (selectedTab === APPROVAL_STATUS.INVOICED) return EmptyState.EMPTY_STATE.APPROVAL_NOTHING_INVOICED;
	return null;
};
